import { DashboardOnboardingStep } from "@/api/__generated__/schemas";
import { Onboarding, OnboardingStepStatus, OnboardingStepValues } from "@/types";

const mapToOnboardingStepStatus = (item: DashboardOnboardingStep): OnboardingStepStatus => ({
  stepType: item.stepType,
  isCompleted: item.isCompleted,
});

export const mapToOnboarding = (items: DashboardOnboardingStep[]): Onboarding => {
  const byType = new Map(items.map((item) => [item.stepType, item]));
  const steps = OnboardingStepValues.map((stepType) =>
    mapToOnboardingStepStatus(
      byType.get(stepType) ?? { stepType, isCompleted: false, completedAt: null }
    )
  );
  return { steps };
};
